import { RESET_STATE } from '../auth/constants';
import {
    REPORTS_HARVEST_INSPECTIONS_SET,
    REPORTS_HARVEST_INSPECTIONS_MERGE,
    REPORTS_HARVEST_INSPECTION_SET
} from './constants';

const initialState = {};

type State = {};

type Action = {
    +type: string,
    +payload: any
};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case REPORTS_HARVEST_INSPECTIONS_SET:
            return action.payload;
        case REPORTS_HARVEST_INSPECTIONS_MERGE:
            return {
                ...state,
                ...action.payload
            };
        case REPORTS_HARVEST_INSPECTION_SET:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
